import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["likeBtn", "count", "shareContainer"];

  toggleLike(event) {
    if (this.likeBtnTarget.classList.contains("already_liked")) {
      this.unlike(event);
    } else {
      this.like(event);
    }
  }

  like(e) {
    e.preventDefault();
    let post_name = this.likeBtnTarget.dataset.postName;
    let data = Site.serializeFormData(this.likeBtnTarget);
    let $this = this;
    Site.postJson(`/likes/${post_name}`, data, response => {
      $this.likeBtnTarget.classList.add("already_liked");
      $this.countTarget.innerText = response.count;
    });
  }

  unlike(e) {
    e.preventDefault();
    let post_name = this.likeBtnTarget.dataset.postName;
    let data = Site.serializeFormData(this.likeBtnTarget);
    let $this = this;
    Site.postJson(`/unlikes/${post_name}`, data, response => {
      $this.likeBtnTarget.classList.remove("already_liked");
      $this.countTarget.innerText = response.count;
    });
  }

  toggleShare() {
    if (this.shareContainerTarget.classList.contains("open")) {
      this.shareContainerTarget.classList.remove("open");
    } else {
      this.shareContainerTarget.classList.add("open");
    }
  }
}
